module.exports = __webpack_public_path__ + "static/img/ballista2.68369a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/ballista2.png
// module id = NA8B
// module chunks = 0